<template>
  <v-card class="rounded-lg fill-height">
    <v-card-title class="pa-6 pb-3">
      <v-row
        dense
        align="center"
      >
        <v-col>
          <div class="subtitle-2 grey--text text--grey-100">
            {{ $t('variables.pain.long') }}
          </div>
        </v-col>
        <v-col
          v-if="removable"
          cols="auto"
        >
          <v-btn
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          v-else
          cols="auto"
        >
          <v-btn-toggle
            v-model="view"
            color="primary"
            mandatory
          >
            <v-btn
              small
              class="text-none"
              value="visual"
            >
              {{ $t('card.display_option.visual') }}
            </v-btn>
            <v-btn
              small
              class="text-none"
              value="list"
            >
              {{ $t('card.display_option.list') }}
            </v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pa-6">
      <div v-if="view === 'visual'">
        <v-row justify="center">
          <v-col
            cols="auto"
            class="justify-center d-flex"
          >
            <human-body-female-front-muscles
              v-if="gender === 'female'"
              style="height: 300px; width: 190px"
              :stats="stats"
              stats-suffix="_DL"
            />
            <human-body-front-muscles
              v-else
              style="height: 300px; width: 190px"
              :stats="stats"
              stats-suffix="_DL"
            />
          </v-col>
          <v-col
            cols="auto"
            class="justify-center d-flex"
          >
            <human-body-female-back-muscles
              v-if="gender === 'female'"
              style="height: 300px; width: 190px"
              :stats="stats"
              stats-suffix="_DL"
            />
            <human-body-back-muscles
              v-else
              style="height: 300px; width: 190px"
              :stats="stats"
              stats-suffix="_DL"
            />
          </v-col>
        </v-row>
      </div>

      <div v-else>
        <v-simple-table
          dense
          fixed-header
          height="325px"
        >
          <thead>
            <tr>
              <th>{{ $t('table_headers.muscle_joint') }}</th>
              <th>{{ $t('variables.pain.long') }}</th>
            </tr>
          </thead>
          <tbody v-if="Object.keys(allPainStats).length === 0">
            <tr>
              <td
                colspan="4"
                class="text-center"
              >
                {{ $t('empty_data.pain_records') }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr
              v-for="(painObject, index) in allPainStats"
              :key="index"
            >
              <td>
                {{ musclesAndJoints[index.toLowerCase()] ? musclesAndJoints[index.toLowerCase()].label : index }}
              </td>
              <td style="width: 15%">
                {{ painObject }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import HumanBodyBackMuscles from '@/components/human-body/HumanBodyBackMuscles'
import HumanBodyFrontMuscles from '@/components/human-body/HumanBodyFrontMuscles'
import HumanBodyFemaleBackMuscles from '@/components/human-body/HumanBodyFemaleBackMuscles'
import HumanBodyFemaleFrontMuscles from '@/components/human-body/HumanBodyFemaleFrontMuscles'
import { musclesAndJoints } from '@/data/models'

export default {
  name: 'PlayerPainWidget',
  components: {
    HumanBodyBackMuscles,
    HumanBodyFrontMuscles,
    HumanBodyFemaleBackMuscles,
    HumanBodyFemaleFrontMuscles
  },
  props: {
    stats: {
      type: Object,
      default: () => ({})
    },
    gender: {
      type: String,
      default: 'male'
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      view: 'visual'
    }
  },
  computed: {
    allPainStats() {
      if (!this.stats || Object.keys(this.stats).length === 0) {
        return {}
      }

      const filtered = {}
      Object.keys(this.stats).forEach(key => {
        const keyWithoutSuffix = key.replace('_DL', '')
        if (this.musclesAndJoints[keyWithoutSuffix.toLowerCase()]) {
          filtered[keyWithoutSuffix] = this.stats[key]
        }
      })

      return filtered
    }
  },
  created() {
    this.musclesAndJoints = musclesAndJoints
  }
}
</script>
